import {
  EntityId,
  PagedResult,
  PagedTenant,
  RequestAvailableSlots,
  Result,
  Tenant,
  TenantComment,
} from "@models";
import requests from "./agent";

export const tenantService = {
  getAll: async (request: PagedTenant) => {
    const response = await requests.get<Result<PagedResult<Tenant>>>(
      "/api/Tenant/GetAll",
      { params: request }
    );
    return response.result;
  },

  getAvailableSlots: async (request: RequestAvailableSlots) => {
    const response = await requests.post<Result<string[]>>(
      "/api/Availability/GetAvailableSlots",
      request
    );
    return response.result;
  },

  get: async (id: EntityId) => {
    const response = await requests.get<Result<Tenant>>(
      "/api/Tenant/Get",
      {
        params: id,
      }
    );
    return response.result;
  },

  getComments: async (tenantId: number, skipCount: number, maxResultCount: number) => {
    const response = await requests.get<Result<PagedResult<TenantComment>>>(
      "/api/TenantRate/GetAll",
      { params: { tenantId, skipCount, maxResultCount } }
    );
    return response.result;
  },
};
